import { X } from "lucide-react";
import { useEffect, useRef, type ReactNode } from "react";

/**
 * A segunda superfície: a tarefa (e depois o assistente) abre aqui sem tirar a pessoa da lista.
 * Computador: coluna de 420 px ao lado do conteúdo. Celular e tablet: tela cheia por cima.
 * Esc fecha; o foco vai para o título ao abrir e volta para quem abriu ao fechar.
 */
export function PainelLateral({ titulo, sobre, aoFechar, acoes, children, rodape }: {
  titulo: ReactNode; sobre?: ReactNode; aoFechar: () => void; acoes?: ReactNode; children: ReactNode; rodape?: ReactNode;
}) {
  const tituloRef = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    const anterior = document.activeElement as HTMLElement | null;
    tituloRef.current?.focus();
    const tecla = (e: KeyboardEvent) => { if (e.key === "Escape") aoFechar(); };
    window.addEventListener("keydown", tecla);
    return () => { window.removeEventListener("keydown", tecla); anterior?.focus?.(); };
  }, [aoFechar]);

  return (
    <aside aria-label="Painel" className="fixed inset-0 z-40 flex flex-col bg-superficie lg:static lg:inset-auto lg:z-auto lg:w-105 lg:shrink-0 lg:fio-l">
      <header className="flex items-start gap-3 fio-b px-4 py-3">
        <div className="min-w-0 flex-1">
          {sobre && <div className="truncate text-meta text-texto-3">{sobre}</div>}
          <h2 ref={tituloRef} tabIndex={-1} className="font-medium break-words text-texto-1 outline-none focus-visible:outline-none">{titulo}</h2>
        </div>
        {acoes}
        <button type="button" onClick={aoFechar}
          className="grid size-controle cursor-pointer place-items-center rounded-controle text-texto-3 hover:bg-superficie-2 hover:text-texto-1">
          <X size={16} aria-hidden /><span className="sr-only">Fechar painel</span>
        </button>
      </header>
      <div className="min-h-0 flex-1 overflow-y-auto p-4">{children}</div>
      {rodape && <footer className="flex flex-wrap justify-end gap-2 fio-t px-4 py-3">{rodape}</footer>}
    </aside>
  );
}

/** Pares rótulo/valor (painel, ficha). */
export function Dados({ itens }: { itens: { rotulo: string; valor: ReactNode }[] }) {
  return (
    <dl className="grid grid-cols-[minmax(0,7rem)_1fr] gap-x-4 gap-y-2">
      {itens.map((i) => (
        <div key={i.rotulo} className="contents">
          <dt className="text-texto-3">{i.rotulo}</dt>
          <dd className="min-w-0 break-words text-texto-1">{i.valor}</dd>
        </div>
      ))}
    </dl>
  );
}
